import { useContext, useEffect, useState } from 'react';
import { requester } from 'App';
import Container from 'routes/vendorRe/containers/commons/Container';
import VerticalFlex from 'routes/vendorRe/containers/commons/VerticalFlex';
import FlexChild from 'routes/vendorRe/containers/commons/FlexChild';
import HorizontalFlex from 'routes/vendorRe/containers/commons/HorizontalFlex';
import P from 'routes/vendorRe/containers/commons/P';
import Center from 'layouts/wrapper/Center';
import { AuthContext } from 'providers/AuthProvider';
import VendorCalc from 'routes/vendorRe/pages/VendorCalc';
import SettlementBest from 'routes/vendor/settlementComp/SettlementBest';
import { useOutletContext } from 'react-router-dom';
import PartnersSettlementStatus from './PartnersSettlementStatus';

function PartnersSalesSettlement() {
    const [isMounted, setMounted] = useState(false);
    const [totalAmount, setTotalAmount] = useState(0);
    const { userName } = useContext(AuthContext);

    const { stores } = useOutletContext();


    useEffect(() => {
        setMounted(true);
        console.log(stores)
    }, []);


    return (
        <Container>
            <Container maxWidth={1200}>
                <VerticalFlex gap={20}>
                    <FlexChild width={"95%"}>
                        <Center width={'100%'} textAlign={'left'}>
                            <P weight={'bold'} size={40}>
                                정산관리
                            </P>
                        </Center>
                    </FlexChild>
                    <FlexChild width={"95%"}>
                        <HorizontalFlex
                            gap={20}
                        >
                            <FlexChild>
                                <HorizontalFlex gap={20} alignItems={'flex-start'}>
                                    <FlexChild> 
                                        {/* 매출 현황 */}
                                        <PartnersSettlementStatus />
                                    </FlexChild>
                                    <FlexChild>
                                        <VendorCalc web />
                                    </FlexChild>



                                </HorizontalFlex>
                            </FlexChild>
                        </HorizontalFlex>
                    </FlexChild>
                    <FlexChild width={"95%"}>
                        {/* 주간 판매량 BEST 3 */}
                        <SettlementBest />
                    </FlexChild>
                </VerticalFlex>
            </Container>
        </Container>
    );
}

export default PartnersSalesSettlement;
